import React from 'react'

function Treatments() {
  return <div>This is program Treatments</div>
}

export default Treatments
